

  export const GetPath = (path) => {
    const paths = path.split('/');
    let [main, module, subMenu = "", param = 0, subTab = ""] = paths.filter(p => p != "")
    return [main, module, subMenu, param, subTab];
  }
  export const ModulePath = (path) => {
    const paths = path.split('/');
    let [ module, subMenu = "", param = 0, subTab = ""] = paths.filter(p => p != "")
    return !subMenu ? module : "";
  }
  export const TabPath = (path) => {
    const paths = path.split('/');
    let [module, subMenu = "", param = 0, subTab = ""] = paths.filter(p => p != "")
    return subTab;
  }
  export const SubMenuPath = (path) => {
    const paths = path.split('/');
    let [module, subMenu = "", param = 0, subTab = ""] = paths.filter(p => p != "")
    return !subTab ? subMenu : "";
  }